export default __webpack_public_path__ + "static/media/iPhone-X1.e0db03e0.png";